import { doMutation } from "../../core-module/util/graphqlHelper";

export const uploadThirdPartyCertificate = ({ trainingRegistrationId, file }) => {
  const mutation = require("../api/mutation/uploadThirdPartyCertificate.gql");
  const variables = { trainingRegistrationId, file };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) return { data: data.uploadThirdPartyCertificate };
    else if (error) return { error: JSON.stringify(error) };
  });
};
